<script lang="ts" setup>
import { Toaster as Sonner, type ToasterProps } from 'vue-sonner'

import { toastOptions } from '.'

const props = defineProps<Omit<ToasterProps, 'toastOptions'>>()
</script>

<template>
  <Sonner
    class="group/toaster"
    v-bind="props"
    :toast-options
  />
</template>
